import React, {FC, ReactNode, useState} from 'react';

import {Trans} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import {DataEventActionsEnum} from '../../../../libs/shared/core/src/models/tracking/dataEventActions';
import {DataEventObjectName} from '../../../../libs/shared/core/src/models/tracking/dataEventObjectName';
import {ChiliPiperProductionRoutersEnum} from '../../../../libs/shared/core/src/services/chilipiper/chilipiper';
import {useDataEventTracking} from '../../../../libs/shared/core/src/services/tracking/dataEventTrackingContext';
import {ChiliPiperDialog} from './chiliPiperDialog';

/*
 * Props.
 */

interface IndividualTrainingChiliPiperDialogProps {
  onRequestClose: () => void;
}

/*
 * Component.
 */

export const IndividualTrainingChiliPiperDialog: FC<IndividualTrainingChiliPiperDialogProps> = (props) => (
  <ChiliPiperDialog
    title={<Trans id="individualtrainingchilipiperdialog-title">Book a setup call</Trans>}
    router={ChiliPiperProductionRoutersEnum.INDIVIDUAL_TRAINING}
    onRequestClose={props.onRequestClose}
  />
);

/*
 * Hook.
 */

export function useIndividualTrainingChiliPiperDialog(
  dataEventObjectName: DataEventObjectName,
): [ReactNode, () => void] {
  const [isDialogVisible, setIsDialogVisible] = useState(false);
  const {trackDataEvent} = useDataEventTracking();

  const onClick = () => {
    setIsDialogVisible(true);
    trackDataEvent(DataEventActionsEnum.CLICK, dataEventObjectName);
  };

  const dialog = isDialogVisible ? (
    <IndividualTrainingChiliPiperDialog onRequestClose={() => setIsDialogVisible(false)} />
  ) : null;

  return [dialog, onClick];
}
